import { useLocation } from 'react-router-dom';
import { sidebarNavigation, SidebarNavigationItem } from './../components/layouts/main/sider/sidebarNavigation';

export const useActiveMenuTitle = (): string => {
  const location = useLocation();
  let activeTitle = '';

  const findActiveMenu = (items: SidebarNavigationItem[]): boolean => {
    for (const item of items) {
      if (item.url === location.pathname) {
        activeTitle = item.title;
        return true;
      }
      if (item.children && findActiveMenu(item.children)) {
        return true;
      }
    }
    return false;
  };

  findActiveMenu(sidebarNavigation);
  return activeTitle || 'Unknown Module';
};

export {};
